import { Button, IconButton } from '@mui/material';
import { MouseEvent } from 'react';
import { MemreIcon } from './index';

export default function MemreButton({
  text,
  iconName,
  variant = 'contained',
  onClick,
  color = 'primary',
  size = 'medium',
  href,
  sx = {},
  disabled = false,
  active = true,
}: {
  text?: string;
  iconName?: any;
  variant?: 'contained' | 'outlined' | 'text' | 'icon';
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  color?: 'primary' | 'secondary' | 'warning' | 'error' | undefined;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  active?: boolean;
  href?: string;
  sx?: any;
}) {
  return variant === 'icon' ? (
    <IconButton
      sx={{ cursor: 'pointer', opacity: active ? 1 : 0.4, ...sx }}
      size={size}
      color={color}
      onClick={onClick}
      disabled={disabled}
    >
      <MemreIcon
        iconName={iconName}
        fontSize={
          {
            medium: '0.8em',
            small: '0.65em',
            large: '1em',
          }[size]
        }
      />
    </IconButton>
  ) : (
    <Button
      sx={{ cursor: 'pointer', ...sx }}
      size={size}
      color={color}
      href={href}
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      endIcon={iconName ? <MemreIcon iconName={iconName} /> : null}
    >
      {text}
    </Button>
  );
}
